import { Pane, Heading, Paragraph, UnorderedList, ListItem } from 'evergreen-ui';

const CookiePolicyPage = () => {
  return (
    <Pane padding={24} background="tint1">
      <Heading size={800} marginBottom={18}>Cookie Policy</Heading>

      <Paragraph size={400} marginBottom={12}>
        Questa pagina spiega quali cookie utilizza il sito, perché li utilizziamo e come puoi gestirli.
      </Paragraph>

      <Heading size={600} marginBottom={8}>Cosa sono i cookie</Heading>
      <Paragraph size={400} marginBottom={12}>
        I cookie sono piccoli file di testo inviati dal sito al tuo dispositivo per salvare informazioni riconducibili alla tua navigazione.
      </Paragraph>

      <Heading size={600} marginBottom={8}>Tipologie di cookie utilizzati</Heading>
      <UnorderedList marginBottom={12}>
        <ListItem><strong>Cookie tecnici</strong>: necessari per il funzionamento del sito.</ListItem>
        <ListItem><strong>Cookie di preferenza</strong>: memorizzano scelte dell'utente (come la lingua, le preferenze UI). L'attivazione richiede il tuo consenso.</ListItem>
        <ListItem><strong>Cookie analitici</strong>: raccolgono dati aggregati per capire come viene usato il sito (es. Google Analytics). L'attivazione richiede il tuo consenso.</ListItem>
        <ListItem><strong>Cookie di marketing/profilazione</strong>: usati per mostrare contenuti pubblicitari rilevanti. L'attivazione richiede il tuo consenso.</ListItem>
      </UnorderedList>

      <Heading size={600} marginBottom={8}>Cookie specifici e terze parti</Heading>
      <Paragraph size={400} marginBottom={12}>
        Il sito può caricare script di terze parti (es. fornitori di analytics o di servizi esterni). Se tali servizi sono attivi, i rispettivi cookie saranno elencati qui.
      </Paragraph>

      <Heading size={600} marginBottom={8}>Gestione e revoca del consenso</Heading>
      <Paragraph size={400} marginBottom={12}>
        Puoi gestire le preferenze cookie cliccando su "Impostazioni cookie" nel footer. Puoi anche cancellare i cookie dalle impostazioni del tuo browser. Nota: la disabilitazione di alcuni cookie tecnici può impedire il corretto funzionamento del sito.
      </Paragraph>

      <Heading size={600} marginBottom={8}>Note</Heading>
      <Paragraph size={400} marginBottom={12}>
        Versione della Policy: 1.0 del 04/11/2025
      </Paragraph>
      <Paragraph size={400} marginBottom={12}>
        Il fornitore del sito web non è responsabile della redazione o conformità legale delle policy (Privacy, Cookie, Termini e Condizioni), che restano a carico del committente. Il fornitore si limiterà alla loro integrazione tecnica sul sito.
      </Paragraph>

    </Pane>
  );
};

export default CookiePolicyPage;
